import React from "react";

import Main from "../../components/Main";

export const Dashboard = () => {
  return (
    <div>
      <Main />
    </div>
  );
};
